// Updated RightDock.jsx
import { ChartBarIncreasing, ChevronDown, RefreshCw } from "lucide-react";
// import ChartRenderer from "./sub_comp/ChartRenderer"; // Legacy artifacts renderer (temporarily disabled)
import AgentRunVizPane from "./sub_comp/AgentRunVizPane";
import {
  RIGHT_DOCK_WIDTH,
  RIGHT_DOCK_TRIGGER_WIDTH,
  RIGHT_DOCK_TOP,
} from "./sub_comp/layoutConstants";
import React, { useEffect, useMemo, useRef, useState } from "react";
import {
  ResponsiveContainer,
  BarChart,
  Bar,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  LineChart,
  Line,
  ScatterChart,
  Scatter,
  ZAxis,
  PieChart,
  Pie,
  Cell,
} from "recharts";

const styles = {
  sidebar: {
    position: "fixed",
    right: `${RIGHT_DOCK_TRIGGER_WIDTH}px`,
    top: RIGHT_DOCK_TOP,
    width: `${RIGHT_DOCK_WIDTH}px`,
    height: `calc(100vh - ${RIGHT_DOCK_TOP}px)`,
    background:
      "linear-gradient(0deg, rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.7)), linear-gradient(0deg, rgba(255, 255, 255, 0.06), rgba(255, 255, 255, 0.06))",
    backdropFilter: "blur(270px)",
    borderLeft: "1px solid #2a2a2a",
    display: "flex",
    flexDirection: "column",
    zIndex: 50,
    transform: "translateX(0)",
    transition: "transform 0.3s ease",
  },
  sidebarHeader: {
    padding: "20px 20px",
    borderBottom: "1px solid #2a2a2a",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    minHeight: "60px",
  },
  sidebarTitle: {
    color: "#ffffff",
    fontSize: "1.125rem",
    fontWeight: "600",
    margin: 0,
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },
  closeButton: {
    backgroundColor: "transparent",
    border: "none",
    color: "#9ca3af",
    cursor: "pointer",
    padding: "6px",
    borderRadius: "4px",
    fontSize: "18px",
    width: "32px",
    height: "32px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    transition: "all 0.15s ease",
  },
  sidebarContent: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
  },
  tabContent: {
    flex: 1,
    overflow: "auto",
    padding: 0, // Remove default padding
  },
  reportContainer: {
    minHeight: "100%",
    display: "flex",
    flexDirection: "column",
    overflow: "visible",
  },
  reportHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "16px",
  },
  reportTitle: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    color: "#ffffff",
    fontSize: "1rem",
    fontWeight: "600",
    margin: 0,
  },
  actionButton: {
    backgroundColor: "transparent",
    border: "1px solid #333333",
    borderRadius: "6px",
    color: "#9ca3af",
    padding: "8px",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    transition: "all 0.15s ease",
    width: "36px",
    height: "36px",
  },
  iframe: {
    flex: 1,
    border: "none",
    borderRadius: "8px",
    backgroundColor: "#1a1a1a",
    minHeight: "400px",
    border: "1px solid #2a2a2a",
  },
  emptyState: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
    textAlign: "center",
    padding: "40px 20px",
  },
  emptyIcon: {
    fontSize: "48px",
    marginBottom: "16px",
    opacity: 0.4,
  },
  emptyTitle: {
    color: "#ffffff",
    fontSize: "1.25rem",
    fontWeight: "600",
    marginBottom: "8px",
    margin: 0,
  },
  emptyText: {
    color: "#6b7280",
    fontSize: "0.875rem",
    lineHeight: "1.5",
    maxWidth: "300px",
    margin: 0,
  },
  versionControls: {
    display: "flex",
    alignItems: "center",
    gap: "6px",
  },
  versionButton: {
    backgroundColor: "rgba(255,255,255,0.05)",
    border: "1px solid rgba(255,255,255,0.15)",
    color: "#f5f5f5",
    width: "28px",
    height: "28px",
    borderRadius: "6px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    fontSize: "0.85rem",
    transition: "all 0.15s ease",
  },
  versionButtonDisabled: {
    opacity: 0.35,
    cursor: "not-allowed",
  },
  versionLabel: {
    color: "#f3f4f6",
    fontSize: "0.85rem",
    fontWeight: 600,
    display: "flex",
    alignItems: "baseline",
    gap: "4px",
  },
  versionCount: {
    color: "#9ca3af",
    fontSize: "0.75rem",
  },
  viewSwitchRow: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: 10,
    padding: "12px 14px 8px 14px",
  },
  viewSwitchCard: {
    borderRadius: 14,
    border: "1px solid rgba(255,255,255,0.1)",
    background: "linear-gradient(140deg, rgba(16,18,26,0.92), rgba(8,9,14,0.9))",
    color: "#e5e7eb",
    padding: "14px 12px",
    textAlign: "left",
    cursor: "pointer",
    display: "grid",
    gap: 6,
    transition: "border-color 0.15s ease, box-shadow 0.15s ease",
    boxShadow: "0 12px 26px rgba(0,0,0,0.35)",
  },
  viewSwitchCardActive: {
    borderColor: "#7a8bff",
    boxShadow: "0 16px 32px rgba(0,0,0,0.45)",
  },
  viewTitle: {
    textTransform: "uppercase",
    letterSpacing: "0.24em",
    fontSize: 11,
    color: "#9ca3af",
  },
  viewPrimary: {
    fontSize: 15,
    fontWeight: 700,
    color: "#f6f7fb",
    lineHeight: 1.3,
  },
  viewMeta: {
    fontSize: 12,
    color: "#cbd0da",
  },
};

export const RightDock = ({
  apiBase,
  artifactImageUrl,
  artifactPlan, // 👈 legacy
  toolEvents = [],
  runOptions = [],
  selectedRunId,
  onSelectRun,
  onClose,
  email,
  finalAnswerReady,
  visualizationsByRunId = {},
  onRequestVisualizations,
}) => {
  const [activeView, setActiveView] = useState("agents");
  const scrollRef = useRef(null);
  const vizState = visualizationsByRunId?.[selectedRunId];
  const displayStatus = finalAnswerReady
    ? vizState?.status || "idle"
    : "idle";
  const displayData = vizState?.data || null;
  const vizError = vizState?.error || null;
  const vizEnabled = Boolean(finalAnswerReady);
  const handleVizRetry = () => {
    if (selectedRunId) {
      onRequestVisualizations?.(selectedRunId);
    }
  };
  useEffect(() => {
    // Scroll to top when visualizations start loading so the user sees the activity.
    if (displayStatus === "loading" && scrollRef.current) {
      scrollRef.current.scrollTo({ top: 0, behavior: "smooth" });
    }
  }, [displayStatus]);

  console.log("RightDock render", {
    apiBase,
    artifactImageUrl,
    artifactPlan,
    selectedRunId,
    runCount: runOptions.length,
  });

  const currentIndex = runOptions.findIndex((r) => r.runId === selectedRunId);
  const effectiveIndex =
    currentIndex >= 0
      ? currentIndex
      : runOptions.length
      ? runOptions.length - 1
      : -1;
  const hasVersionNav = effectiveIndex >= 0;
  const hasPrev = hasVersionNav && effectiveIndex > 0;
  const hasNext =
    hasVersionNav && effectiveIndex < runOptions.length - 1;
  const versionLabel = hasVersionNav
    ? runOptions[effectiveIndex]?.label || `v${effectiveIndex + 1}`
    : "Live";
  const versionCount = hasVersionNav
    ? `${effectiveIndex + 1}/${runOptions.length}`
    : null;
  const insightReady = displayStatus === "ready";
  const agentSummary = useMemo(() => {
    const map = new Map();
    (toolEvents || []).forEach((evt) => {
      if (!evt) return;
      const key = evt.agentSlug || evt.agentName || evt.toolSlug || evt.id;
      if (!key) return;
      const status = typeof evt.status === "string" ? evt.status.toLowerCase() : "";
      map.set(key, status);
    });
    let completed = 0;
    let running = 0;
    map.forEach((status) => {
      if (status === "completed") completed += 1;
      else if (status === "running") running += 1;
    });
    return { completed, running, total: map.size };
  }, [toolEvents]);

  const goToIndex = (idx) => {
    if (idx < 0 || idx >= runOptions.length) return;
    const target = runOptions[idx];
    if (!target) return;
    onSelectRun?.(target.runId);
  };

  useEffect(() => {
    if (displayStatus === "ready") {
      setActiveView("insights");
    }
  }, [displayStatus]);

  return (
    <aside style={styles.sidebar}>
      {/* Header */}
      <div style={styles.sidebarHeader}>
        <h2 style={styles.sidebarTitle}>
          <ChartBarIncreasing size={20} />
          {/* <span>Visualisations</span> */}
          <span>Agent Runs</span>
        </h2>
        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          {hasVersionNav && (
            <div style={styles.versionControls}>
              <button
                style={{
                  ...styles.versionButton,
                  ...(hasPrev ? {} : styles.versionButtonDisabled),
                }}
                onClick={() => hasPrev && goToIndex(effectiveIndex - 1)}
                disabled={!hasPrev}
              >
                ‹
              </button>
              <div style={styles.versionLabel}>
                <span>{versionLabel}</span>
                {versionCount ? (
                  <span style={styles.versionCount}>{versionCount}</span>
                ) : null}
              </div>
              <button
                style={{
                  ...styles.versionButton,
                  ...(hasNext ? {} : styles.versionButtonDisabled),
                }}
                onClick={() => hasNext && goToIndex(effectiveIndex + 1)}
                disabled={!hasNext}
              >
                ›
              </button>
            </div>
          )}
          <button
            style={styles.closeButton}
            onClick={onClose}
            onMouseOver={(e) => {
              e.target.style.backgroundColor = "#1a1a1a";
              e.target.style.color = "#ffffff";
            }}
            onMouseOut={(e) => {
              e.target.style.backgroundColor = "transparent";
              e.target.style.color = "#9ca3af";
            }}
          >
            ×
          </button>
        </div>
      </div>

      {/* Content */}
      <div style={styles.sidebarContent}>
        <div style={styles.viewSwitchRow}>
          <button
            style={{
              ...styles.viewSwitchCard,
              ...(activeView === "insights" ? styles.viewSwitchCardActive : {}),
              opacity: insightReady ? 1 : 0.35,
              cursor: insightReady ? "pointer" : "not-allowed",
            }}
            onClick={() => insightReady && setActiveView("insights")}
          >
            <div style={styles.viewTitle}>Insights</div>
            <div style={styles.viewPrimary}>Visualizations</div>
            <div style={styles.viewMeta}>
              {displayStatus === "loading"
                ? "Generating..."
                : insightReady
                ? "Ready"
                : "Pending"}
            </div>
          </button>
          <button
            style={{
              ...styles.viewSwitchCard,
              ...(activeView === "agents" ? styles.viewSwitchCardActive : {}),
            }}
            onClick={() => setActiveView("agents")}
          >
            <div style={styles.viewTitle}>Live Agent Runs</div>
            <div style={styles.viewPrimary}>
              {agentSummary.completed}/{agentSummary.total || agentSummary.completed + agentSummary.running || 0} completed reports
            </div>
            <div style={styles.viewMeta}>
              {agentSummary.running} running
            </div>
          </button>
        </div>

        {activeView === "insights" && (
          <div style={styles.tabContent} ref={scrollRef}>
            <div
              style={{
                ...styles.reportContainer,
                overflow: "hidden",
              }}
            >
              {finalAnswerReady ? (
                <VisualizationsPanel
                  status={displayStatus}
                  data={displayData}
                  error={vizError}
                  onRetry={handleVizRetry}
                  isEnabled={vizEnabled}
                  hideHeader
                />
              ) : (
                <div style={{ padding: "20px" }}>
                  <div
                    style={{
                      border: "1px dashed rgba(255,255,255,0.08)",
                      borderRadius: 12,
                      padding: "18px",
                      color: "#9ca3af",
                      fontSize: 13,
                      textAlign: "center",
                      background: "rgba(255,255,255,0.02)",
                    }}
                  >
                    Visualizations will appear once the answer is ready.
                  </div>
                </div>
              )}
            </div>
          </div>
        )}

        {activeView === "agents" && (
          <div style={styles.tabContent}>
            <div style={{ flex: 1, minHeight: 0, display: "flex" }}>
              {toolEvents && toolEvents.length ? (
                <div style={{ flex: 1, minHeight: 0 }}>
                  <AgentRunVizPane events={toolEvents} showHeader={false} />
                </div>
              ) : (
                <div
                  style={{
                    flex: 1,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <div style={styles.emptyState}>
                    <div style={styles.emptyIcon}>🎯</div>
                    <h3 style={styles.emptyTitle}>No Agent Activity Yet</h3>
                    <p style={styles.emptyText}>
                      Open Agent Runs to follow tasks as they execute.
                    </p>
                  </div>
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    </aside>
  );
};

function VisualizationsPanel({ status, data, error, onRetry, isEnabled, hideHeader = false }) {
  const charts = Array.isArray(data?.charts) ? data.charts : [];
  const callouts = Array.isArray(data?.callouts) ? data.callouts : [];
  const hasContent = charts.length > 0 || callouts.length > 0;
  const sectionTitle = data?.section?.title || "Visualizations";
  const sectionSubtitle = data?.section?.subtitle;
  const [expandedIndex, setExpandedIndex] = useState(0);

  useEffect(() => {
    // Default to first chart open when payload changes
    setExpandedIndex(charts.length ? 0 : -1);
  }, [charts.length, status]);

  if (!isEnabled && !hasContent) return null;

  return (
    <div
      style={{
        padding: hideHeader ? "0px 16px 16px 16px" : "20px",
        borderBottom: "1px solid rgba(255,255,255,0.06)",
        background: "rgba(10,10,16,0.65)",
        flexShrink: 0,
      }}
    >
      {!hideHeader && (
        <div
          style={{
            display: "flex",
            alignItems: "baseline",
            justifyContent: "space-between",
            marginBottom: 12,
          }}
        >
          <div>
            <div
              style={{
                textTransform: "uppercase",
                letterSpacing: "0.25em",
                fontSize: 11,
                color: "#9ca3af",
              }}
            >
              Insights
            </div>
            <h3
              style={{
                margin: "6px 0 0",
                color: "#f3f4f6",
                fontSize: 16,
              }}
            >
              {sectionTitle}
            </h3>
            {sectionSubtitle ? (
              <p
                style={{
                  margin: "4px 0 0",
                  fontSize: 13,
                  color: "#9ca3af",
                }}
              >
                {sectionSubtitle}
              </p>
            ) : null}
          </div>
          {status === "loading" && (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 8,
                color: "#9ca3af",
                fontSize: 12,
              }}
            >
              <RefreshCw size={16} className="spin" />
              Generating…
            </div>
          )}
        </div>
      )}

      {status === "error" && (
        <div
          style={{
            border: "1px solid rgba(248,113,113,0.4)",
            background: "rgba(248,113,113,0.08)",
            borderRadius: 12,
            padding: "16px",
            color: "#fecaca",
            fontSize: 13,
            display: "grid",
            gap: 12,
          }}
        >
          <div>
            Unable to load visualizations. {error?.message || "Unknown error."}
          </div>
          <button
            onClick={onRetry}
            style={{
              alignSelf: "start",
              border: "1px solid rgba(248,113,113,0.6)",
              background: "transparent",
              color: "#fecaca",
              borderRadius: 999,
              padding: "6px 16px",
              cursor: "pointer",
            }}
          >
            Retry
          </button>
        </div>
      )}

      {status === "loading" && !hasContent && (
        <div
          style={{
            border: "1px dashed rgba(255,255,255,0.1)",
            borderRadius: 12,
            padding: "20px",
            color: "#9ca3af",
            fontSize: 13,
            textAlign: "center",
          }}
        >
          Generating visualizations…
        </div>
      )}

      {status === "ready" && !hasContent && (
        <div
          style={{
            border: "1px dashed rgba(255,255,255,0.1)",
            borderRadius: 12,
            padding: "20px",
            color: "#9ca3af",
            fontSize: 13,
            textAlign: "center",
          }}
        >
          No visualizations were generated for this run.
        </div>
      )}

      {hasContent && (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: 16,
            marginTop: 12,
          }}
        >
          {callouts.length > 0 && (
            <div
              style={{
                border: "1px solid rgba(129,140,248,0.25)",
                borderRadius: 16,
                background:
                  "linear-gradient(135deg, rgba(99,102,241,0.08), rgba(12,14,24,0.95))",
                padding: "16px 18px",
                boxShadow: "0 12px 30px rgba(0,0,0,0.25)",
              }}
            >
              <div
                style={{
                  textTransform: "uppercase",
                  letterSpacing: "0.2em",
                  color: "#c7d2fe",
                  fontSize: 11,
                  marginBottom: 10,
                }}
              >
                Recommended Strategy
              </div>
              <div style={{ display: "grid", gap: 10 }}>
                {callouts.map((callout, idx) => (
                  <div
                    key={`${callout.title || "callout"}_${idx}`}
                    style={{
                      display: "flex",
                      gap: 10,
                      alignItems: "flex-start",
                    }}
                  >
                    <div
                      style={{
                        width: 24,
                        height: 24,
                        borderRadius: "50%",
                        background: "rgba(129,140,248,0.14)",
                        border: "1px solid rgba(129,140,248,0.3)",
                        color: "#e0e7ff",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontWeight: 700,
                        fontSize: 12,
                        flexShrink: 0,
                      }}
                    >
                      {idx + 1}
                    </div>
                    <div style={{ display: "grid", gap: 4 }}>
                      <div
                        style={{
                          fontSize: 13,
                          fontWeight: 700,
                          color: "#f3f4f6",
                        }}
                      >
                        {callout.title || `Callout ${idx + 1}`}
                      </div>
                      <p
                        style={{
                          margin: 0,
                          color: "#d1d5db",
                          fontSize: 13,
                          lineHeight: 1.5,
                        }}
                      >
                        {callout.body}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}

          {charts.length > 0 ? (
            <div style={{ display: "grid", gap: 12 }}>
              {charts.map((chart, idx) => {
                const isOpen = expandedIndex === idx;
                return (
                  <div
                    key={chart.id || chart.title || idx}
                    style={{
                      border: "1px solid rgba(255,255,255,0.08)",
                      borderRadius: 16,
                      background:
                        "linear-gradient(145deg, rgba(15,18,30,0.85), rgba(8,9,16,0.9))",
                      overflow: "hidden",
                    }}
                  >
                    <button
                      onClick={() =>
                        setExpandedIndex((prev) =>
                          prev === idx ? -1 : idx
                        )
                      }
                      style={{
                        width: "100%",
                        textAlign: "left",
                        border: "none",
                        background: "transparent",
                        padding: "14px 16px",
                        display: "flex",
                        alignItems: "center",
                        gap: 12,
                        cursor: "pointer",
                      }}
                    >
                      <div
                        style={{
                          width: 28,
                          height: 28,
                          borderRadius: "50%",
                          background: "rgba(236,16,163,0.12)",
                          color: "#f9a8d4",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          fontWeight: 700,
                          fontSize: 12,
                          flexShrink: 0,
                        }}
                      >
                        {idx + 1}
                      </div>
                      <div style={{ flex: 1, minWidth: 0 }}>
                        <div
                          style={{
                            color: "#f3f4f6",
                            fontSize: 15,
                            fontWeight: 600,
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                          }}
                        >
                          {chart.title || `Chart ${idx + 1}`}
                        </div>
                        {chart.description ? (
                          <div
                            style={{
                              color: "#9ca3af",
                              fontSize: 12,
                              marginTop: 4,
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                            }}
                          >
                            {chart.description}
                          </div>
                        ) : null}
                      </div>
                      {chart.tag ? (
                        <span
                          style={{
                            border: "1px solid rgba(236,196,253,0.4)",
                            color: "#f5d0fe",
                            borderRadius: 999,
                            padding: "4px 12px",
                            fontSize: 11,
                            letterSpacing: "0.1em",
                            flexShrink: 0,
                          }}
                        >
                          {chart.tag}
                        </span>
                      ) : null}
                      <ChevronDown
                        size={18}
                        color="#d1d5db"
                        style={{
                          transition: "transform 0.2s ease",
                          transform: isOpen ? "rotate(180deg)" : "rotate(0deg)",
                          flexShrink: 0,
                        }}
                      />
                    </button>
                    {isOpen && (
                      <div
                        style={{
                          borderTop: "1px solid rgba(255,255,255,0.06)",
                          padding: "12px 12px 16px 12px",
                          display: "grid",
                          gap: 12,
                        }}
                      >
                        <div style={{ height: 320 }}>
                          <DynamicChart chart={chart} />
                        </div>
                        {chart.why_this_matters ? (
                          <div
                            style={{
                              padding: "12px 14px",
                              borderRadius: 12,
                              border: "1px solid rgba(255,255,255,0.07)",
                              background: "rgba(255,255,255,0.02)",
                              color: "#d1d5db",
                              fontSize: 13,
                              lineHeight: 1.5,
                            }}
                          >
                            <span
                              style={{
                                color: "#f9fafb",
                                fontWeight: 700,
                              }}
                            >
                              Why this matters:
                            </span>{" "}
                            {chart.why_this_matters}
                          </div>
                        ) : null}
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          ) : (
            <div
              style={{
                border: "1px dashed rgba(255,255,255,0.1)",
                borderRadius: 12,
                padding: "20px",
                color: "#9ca3af",
                fontSize: 13,
                textAlign: "center",
              }}
            >
              No visualizations were generated for this run.
            </div>
          )}
        </div>
      )}
    </div>
  );
}

const SERIES_COLORS = ["#a5b4fc", "#f472b6", "#34d399", "#fcd34d", "#60a5fa"];

function YAxisLabel({ value, axisType, offset, orientation, height, width, textAnchor = "middle" }) {
  if (!value) return null;
  const isVertical = axisType === "yAxis";
  if (!isVertical) return null;
  const x = orientation === "right" ? width + offset : -offset;
  const y = height / 2;
  const rotation = -90;
  return (
    <g transform={`translate(${x},${y})`}>
      <text
        x={0}
        y={0}
        fill="#cbd5f5"
        textAnchor={textAnchor}
        dominantBaseline="middle"
        transform={`rotate(${rotation})`}
      >
        {value}
      </text>
    </g>
  );
}

function buildYAxisConfigs(chart = {}) {
  const configs = [];
  const existing = new Set();

  (Array.isArray(chart.yAxes) ? chart.yAxes : []).forEach((axis, idx) => {
    const axisId = axis?.yAxisId || (idx === 0 ? "left" : `axis_${idx}`);
    existing.add(axisId);
    configs.push({ ...axis, yAxisId: axisId });
  });

  const requiredIds = new Set(
    (Array.isArray(chart.series) ? chart.series : [])
      .map((serie) => {
        if (!serie || typeof serie !== "object") return null;
        const id = serie.yAxisId;
        if (typeof id === "string" && id.trim()) return id.trim();
        return null;
      })
      .filter(Boolean)
  );

  requiredIds.forEach((id) => {
    if (existing.has(id)) return;
    existing.add(id);
    configs.push({
      yAxisId: id,
      orientation: id.toLowerCase().includes("right") ? "right" : "left",
    });
  });

  if (!configs.length) {
    configs.push({ yAxisId: "left" });
  }

  return configs;
}

function applyAxisLabelDefaults(axis = {}, chart = {}) {
  const orientation = axis.orientation || "left";
  const isRight = orientation === "right";
  let longestTick = 0;
  const dataKey = axis.dataKey || chart.yKey;
  if (dataKey && Array.isArray(chart.data)) {
    chart.data.forEach((row) => {
      const value = row?.[dataKey];
      if (value === null || typeof value === "undefined") return;
      const len = String(Math.round(Number(value))).length;
      longestTick = Math.max(longestTick, len);
    });
  }
  const useInside = longestTick <= 4;
  const defaultLabel = {
    position: useInside
      ? isRight
        ? "insideRight"
        : "insideLeft"
      : isRight
      ? "outsideRight"
      : "outsideLeft",
    offset: 28,
  };
  if (!axis.label) return defaultLabel;
  return {
    ...defaultLabel,
    ...axis.label,
  };
}

function DynamicChart({ chart }) {
  if (!chart || !Array.isArray(chart.data) || chart.data.length === 0) {
    return (
      <div
        style={{
          height: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "#9ca3af",
          fontSize: 12,
        }}
      >
        No data provided for this visualization.
      </div>
    );
  }

  const type = (chart.type || "").toLowerCase();
  const margin = chart.margin || { top: 20, right: 20, bottom: 24, left: 40 };
  const renderLegend = (chart.series || []).length > 1;
  const yAxisConfigs = buildYAxisConfigs(chart);
  const defaultYAxisId = yAxisConfigs[0]?.yAxisId || "left";
  const renderYAxes = (extraProps) =>
    yAxisConfigs.map((axis, idx) => {
      const applied =
        typeof extraProps === "function" ? extraProps(axis, idx) : extraProps;
      const combinedAxis = { ...axis, ...(applied || {}) };
      return (
        <YAxis
          key={axis.yAxisId || idx}
          {...combinedAxis}
          stroke={combinedAxis.stroke || "#cbd5f5"}
          padding={{ top: 12, bottom: 12 }}
          tick={{ fontSize: 10, fill: "#cbd5f5" }}
          label={(() => {
            const label = applyAxisLabelDefaults(combinedAxis, chart);
            if (!label.value) return undefined;
            const isRight = (combinedAxis.orientation || "left") === "right";
            const dx = isRight ? 24 : -24;
            const dy = 0;
            return {
              value: label.value,
              angle: -90,
              position: isRight ? "outsideRight" : "outsideLeft",
              dx,
              dy,
            };
          })()}
        />
      );
    });

  if (type === "barchart" || type === "bar") {
    return (
      <ResponsiveContainer width="100%" height="100%">
        <BarChart
          data={chart.data}
          layout={chart.layout || "horizontal"}
          margin={margin}
        >
          <CartesianGrid strokeDasharray="3 3" stroke="rgba(255,255,255,0.08)" />
          <XAxis
            dataKey={chart.xKey}
            stroke="#cbd5f5"
            tick={{ fontSize: 11 }}
            angle={chart.xAxisAngle || 0}
            textAnchor={chart.xAxisAngle ? "end" : "middle"}
          />
          {renderYAxes()}
          <Tooltip contentStyle={{ background: "#111827", border: "none" }} />
          {renderLegend && (
            <Legend
              verticalAlign="top"
              height={24}
              wrapperStyle={{ color: "#9ca3af", fontSize: 11 }}
            />
          )}
          {(chart.series || []).map((serie, idx) => (
            <Bar
              key={serie.dataKey || idx}
              dataKey={serie.dataKey}
              name={serie.name}
              yAxisId={serie.yAxisId || defaultYAxisId}
              stackId={serie.stackId}
              fill={serie.color || SERIES_COLORS[idx % SERIES_COLORS.length]}
              radius={serie.radius || [4, 4, 0, 0]}
            />
          ))}
        </BarChart>
      </ResponsiveContainer>
    );
  }

  if (type === "linechart" || type === "line") {
    return (
      <ResponsiveContainer width="100%" height="100%">
        <LineChart data={chart.data} margin={margin}>
          <CartesianGrid strokeDasharray="3 3" stroke="rgba(255,255,255,0.08)" />
          <XAxis
            dataKey={chart.xKey}
            stroke="#cbd5f5"
            tick={{ fontSize: 11 }}
          />
          {renderYAxes()}
          <Tooltip contentStyle={{ background: "#111827", border: "none" }} />
          {renderLegend && (
            <Legend
              verticalAlign="top"
              wrapperStyle={{ color: "#9ca3af", fontSize: 11 }}
            />
          )}
          {(chart.series || []).map((serie, idx) => (
            <Line
              key={serie.dataKey || idx}
              type={serie.curve || "monotone"}
              dataKey={serie.dataKey}
              name={serie.name}
              yAxisId={serie.yAxisId || defaultYAxisId}
              stroke={serie.color || SERIES_COLORS[idx % SERIES_COLORS.length]}
              strokeWidth={2}
              dot={false}
            />
          ))}
        </LineChart>
      </ResponsiveContainer>
    );
  }

  if (type === "scatterchart" || type === "scatter") {
    const scatterYKey = chart.yKey || chart.series?.[0]?.dataKey;
    return (
      <ResponsiveContainer width="100%" height="100%">
        <ScatterChart margin={margin}>
          <CartesianGrid strokeDasharray="3 3" stroke="rgba(255,255,255,0.08)" />
          <XAxis
            dataKey={chart.xKey}
            stroke="#cbd5f5"
            tick={{ fontSize: 11 }}
          />
          {renderYAxes((axis) => ({
            dataKey: axis.dataKey || scatterYKey,
            tick: { fontSize: 11 },
          }))}
          {chart.sizeKey ? (
            <ZAxis dataKey={chart.sizeKey} range={[80, 400]} />
          ) : null}
          <Tooltip contentStyle={{ background: "#111827", border: "none" }} />
          {(chart.series || [{ dataKey: chart.yKey }]).map((serie, idx) => (
            <Scatter
              key={serie.dataKey || idx}
              data={chart.data}
              yAxisId={serie.yAxisId || defaultYAxisId}
              fill={serie.color || SERIES_COLORS[idx % SERIES_COLORS.length]}
            />
          ))}
        </ScatterChart>
      </ResponsiveContainer>
    );
  }

  if (type === "piechart" || type === "pie") {
    const pieKey = chart.series?.[0]?.dataKey || chart.dataKey;
    const labelKey = chart.labelKey || chart.xKey;
    return (
      <ResponsiveContainer width="100%" height="100%">
        <PieChart>
          <Tooltip contentStyle={{ background: "#111827", border: "none" }} />
          <Legend
            layout="vertical"
            align="right"
            verticalAlign="middle"
            wrapperStyle={{ color: "#9ca3af", fontSize: 11 }}
          />
          <Pie
            data={chart.data}
            dataKey={pieKey}
            nameKey={labelKey}
            innerRadius="50%"
            outerRadius="80%"
            paddingAngle={2}
          >
            {chart.data.map((entry, idx) => (
              <Cell
                key={`cell-${idx}`}
                fill={SERIES_COLORS[idx % SERIES_COLORS.length]}
              />
            ))}
          </Pie>
        </PieChart>
      </ResponsiveContainer>
    );
  }

  return (
    <div
      style={{
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: "#9ca3af",
        fontSize: 12,
        textAlign: "center",
        padding: "0 24px",
      }}
    >
      Unsupported chart type: {chart.type || "unknown"}.
    </div>
  );
}
